import React, { useEffect, useRef, useState } from "react";
import {
  faChevronRight,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useSearchParams } from "react-router-dom";
import "../style/About.css";
import "../style/Common.css";
import aboutUs from "../images/More.jpg";
import aboutUsMobile from "../images/doctor-checking.jpg";
import "../style/More.css";
import styles from "../style/FAQs.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import YoutubeGrid from "./YoutubeGrid";
import faqicon from "../images/icon-faq.png";
import { useMediaQuery } from "react-responsive";

const contentMapping = {
  General: [
    {
      question: "How do I start my treatment?",
      answer:
        "Simply schedule a consultation with our experts, and we’ll guide you through each step of the process to begin your smile transformation.",
    },
    {
      question: "What happens during the consultation?",
      answer:
        "Our orthodontists will assess your dental health, understand your goals, and create a personalized treatment plan to ensure optimal results.",
    },
    {
      question: "How does Lamaan's treatment work?",
      answer:
        "Lamaan treatment involves a series of custom-made, invisible aligners that gradually shift your teeth into their desired position.",
    },
    {
      question: "How long will my treatment take?",
      answer:
        "The treatment duration typically ranges from 6 to 12 months, depending on the specific needs of your smile.",
    },
    {
      question: "Are the aligners comfortable?",
      answer:
        "Absolutely! Lamaan aligners are designed for comfort, with a smooth and secure fit that minimizes irritation and fits seamlessly into your daily life.",
    },
    {
      question: "How is Lamaan more affordable than traditional treatments?",
      answer:
        "We reduce overhead costs and streamline the treatment process, allowing us to offer high-quality care at a significantly lower price than in-clinic treatments.",
    },
  ],
  Guarantee: [
    {
      question: "What does the Lamaan smile guarantee cover?",
      answer:
        "Our guarantee ensures expert-guided treatment for lasting results, helping you achieve and maintain a confident smile.",
    },
    {
      question: "Will I need additional aligners after treatment?",
      answer:
        "Our plans are designed for the best results, but refinements may be needed. Your doctor will assess and recommend if necessary.",
    },
    {
      question: "How does Lamaan ensure long-term smile satisfaction?",
      answer:
        "We offer expert consultations, precise treatment planning, and high-quality aligners. Retainers may be advised to maintain your results.",
    },
    {
      question: "What if I’m not satisfied with my results?",
      answer:
        "Your satisfaction is our priority. If you followed the plan and still have concerns, our team will work with you to find the best solution.",
    },
  ],
};

const FAQs = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedSection, setSelectedSection] = useState("General");
  const [searchParams] = useSearchParams();
  const focus = searchParams.get("focus");
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    if (focus === "warranty") {
      setSelectedSection("Guarantee");
      window.scrollTo({
        top: window.innerHeight / 2,
        behavior: "smooth",
      });
    }
  }, [focus]);

  const handleSectionClick = (index, section) => {
    setSelectedSection(section);
    setActiveIndex(null);
  };

  const contentRefs = useRef([]);

  useEffect(() => {
    contentRefs.current.forEach((ref, index) => {
      if (ref) {
        const offset = 50;
        ref.style.maxHeight =
          activeIndex === index ? `${ref.scrollHeight + offset}px` : "0px";
      }
    });
  }, [activeIndex, selectedSection]);

  return (
    <section className="more" id="more">
      <div className="about-us-container">
        <div className="about-us-content">
          <h1>FAQs</h1>
          <nav className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>FAQ</span>
          </nav>
        </div>
        <div className="about-us-image">
          {isMobile ? (
            <img src={aboutUsMobile} alt="About Us" className="mobile-image" />
          ) : (
            <img src={aboutUs} alt="About Us" />
          )}
        </div>
      </div>
      <YoutubeGrid />
      <div className={styles.titleContainer}>
        <img src={faqicon} alt="FAQ" />
        <div>
          <h1 className={styles.title}>Frequently Asked Questions</h1>
          <h1 className={styles.subtitle}>Answer to popular Questions</h1>
        </div>
      </div>
      <div className={styles.accordionContainer}>
        <div className={styles.sideMenu}>
          {Object.keys(contentMapping).map((item, index) => (
            <div
              key={index}
              className={`${styles.menuItem} ${
                selectedSection === item ? styles.active : ""
              }`}
              onClick={() => handleSectionClick(index, item)}
            >
              {item}
              <FontAwesomeIcon icon={faChevronRight} className={styles.icon} />
            </div>
          ))}
        </div>
        <div className={styles.content}>
          {contentMapping[selectedSection].map((item, index) => (
            <div
              key={index}
              className={`${styles.accordionItem} ${
                activeIndex === index ? styles.expanded : ""
              }`}
            >
              <div
                className={`${styles.accordionHeader} ${
                  activeIndex === index ? styles.expanded : ""
                }`}
                onClick={() =>
                  setActiveIndex(index === activeIndex ? null : index)
                }
              >
                {item.question}
                {activeIndex === index ? (
                  <FontAwesomeIcon icon={faMinus} size="lg" />
                ) : (
                  <FontAwesomeIcon icon={faPlus} size="md" />
                )}
              </div>
              <div
                ref={(el) => (contentRefs.current[index] = el)}
                className={`${styles.accordionContent}`}
                style={{
                  maxHeight:
                    activeIndex === index
                      ? `${contentRefs.current[index]?.scrollHeight + 50}px`
                      : "0px",
                }}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <AltFAQ /> */}
    </section>
  );
};

export default FAQs;
